// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11aok","left":"styles_left__2b3YD","desktopActions":"styles_desktopActions__3zsVw","title":"styles_title__2L3RH"};